import { SET_DELIVERY_STATE, SET_DELIVERY_STATUS, SET_IS_FETCHING_DELIVERY } from 'reducers/actions-types';
import { orderExpiration as orderExpirationURL } from 'constants/api-urls';

import axios from 'axios';

/**
 * Handle fetch
 * @param {IDeliveryState} data
 * @param {function} dispatch
 */
function handleFetch(data, dispatch) {
    const newState = {
        now: data.now,
        date: data.date,
        minDate: data.min_date,
        maxDate: data.max_date,
        status: data.state,
        hasFetched: true,
    };

    dispatch({ type: SET_IS_FETCHING_DELIVERY, isFetching: false });
    dispatch({ type: SET_DELIVERY_STATE, newState });
}

function handleError(error, dispatch) {
    dispatch({ type: SET_IS_FETCHING_DELIVERY, isFetching: false });
    dispatch({ type: SET_DELIVERY_STATE, newState: { hasFetched: true } });
}

export default Object.freeze({
    /**
     * set new date on delivery
     * @param {string} date
     * @return {function(*=): Promise<void | never>}
     */
    setDate({ date }) {
        return (dispatch) => {
            dispatch({ type: SET_IS_FETCHING_DELIVERY, isFetching: true });
            return axios.post(orderExpirationURL(), { date })
                .then(({ data }) => handleFetch(data, dispatch))
                .catch(error => handleError(error, dispatch));
        };
    },
    /**
     * Set order status
     * @param {string} status
     * @return {{type: *, status: *}}
     */
    setStatus({ status }) {
        return { type: SET_DELIVERY_STATUS, status };
    },
    fetchState() {
        return (dispatch) => {
            dispatch({ type: SET_IS_FETCHING_DELIVERY, isFetching: true });
            return axios.get(orderExpirationURL())
                .then(({ data }) => handleFetch(data, dispatch) || data)
                .catch(error => handleError(error, dispatch) || Promise.reject(error));
        };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/delivery/actions.js